import React, { useState } from 'react';
import { FileCheck, ShieldCheck, Layers, Sparkles } from 'lucide-react';
import { CompletedWorksFeed } from '../../../components/pto/CompletedWorksFeed';
import { ActsRegistry } from '../../../components/pto/ActsRegistry';
import { CertificateManager } from '../../../components/pto/CertificateManager';
import { Ks6aLedger } from '../../../components/pto/Ks6aLedger';

export const PtoModule: React.FC = () => {
  const [subTab, setSubTab] = useState<'feed' | 'acts' | 'certs' | 'ks6a'>('feed');

  return (
    <div className="space-y-6">
      {/* Sub Navigation Bar */}
      <div className="flex bg-white p-1.5 rounded-2xl border border-slate-200/90 max-w-2xl mx-auto overflow-x-auto shadow-sm gap-1.5">
        <button
          type="button"
          onClick={() => setSubTab('feed')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-xs sm:text-sm font-semibold transition whitespace-nowrap active:scale-95 ${
            subTab === 'feed'
              ? 'bg-emerald-600 text-white shadow-md shadow-emerald-600/20 font-extrabold'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Sparkles className="w-4 h-4" />
          <span>1. Лента сдачи</span>
        </button>

        <button
          type="button"
          onClick={() => setSubTab('acts')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-xs sm:text-sm font-semibold transition whitespace-nowrap active:scale-95 ${
            subTab === 'acts'
              ? 'bg-blue-600 text-white shadow-md shadow-blue-600/20 font-extrabold'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <FileCheck className="w-4 h-4" />
          <span>2. Реестр АОСР</span>
        </button>

        <button
          type="button"
          onClick={() => setSubTab('certs')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-xs sm:text-sm font-semibold transition whitespace-nowrap active:scale-95 ${
            subTab === 'certs'
              ? 'bg-amber-500 text-slate-950 shadow-md shadow-amber-500/20 font-extrabold'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <ShieldCheck className="w-4 h-4" />
          <span>3. Сертификаты</span>
        </button>

        <button
          type="button"
          onClick={() => setSubTab('ks6a')}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-xl text-xs sm:text-sm font-semibold transition whitespace-nowrap active:scale-95 ${
            subTab === 'ks6a'
              ? 'bg-purple-600 text-white shadow-md shadow-purple-600/20 font-extrabold'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Layers className="w-4 h-4" />
          <span>4. Ведомость КС-6а</span>
        </button>
      </div>

      {/* Subtab View */}
      {subTab === 'feed' && <CompletedWorksFeed />}
      {subTab === 'acts' && <ActsRegistry />}
      {subTab === 'certs' && <CertificateManager />}
      {subTab === 'ks6a' && <Ks6aLedger />}
    </div>
  );
};

export default PtoModule;
